<template>
  <div>
    <b-modal
      visible
      size="lg"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      body-class="bg-transparent"
      content-class="hide-line"
    >
      <div class="card-image-overlay">
        <div class="card-image-panel">
          <font-awesome-icon
            @click="$emit('close')"
            icon="times-circle"
            class="close-icon"
          ></font-awesome-icon>

          <div class="">
            <template v-if="type == 'pdf'">
              <pdf :src="img" style="width: 60vw"> </pdf>
            </template>
            <b-img v-else :src="img" alt="id card image"></b-img>
          </div>
        </div>
      </div>

      <div class="bg-white pb-1" v-if="form.is_id_card">
        <div class="title-tabs f-16 mt-4">ข้อมูลบัตรประชาชน</div>
        <div class="d-flex mt-3">
          <div style="min-width: 150px" class="text-center">
            <img
              v-if="isshowIdCardImg"
              :src="form.id_card_profile_picture"
              alt="ID Card Photo"
              style="width: 120px; height: auto; object-fit: cover"
            />
            <b-button
              v-if="!isshowIdCardImg"
              @click="showIdCardImg()"
              variant="outline-primary"
              class="border-btn mt-2"
              ><font-awesome-icon icon="eye" class="mr-2"></font-awesome-icon>
              แสดงภาพ</b-button
            >
            <b-button
              v-else
              @click="showIdCardImg()"
              variant="outline-primary"
              class="border-btn mt-2"
              ><font-awesome-icon
                icon="eye-slash"
                class="mr-2"
              ></font-awesome-icon>
              ซ่อนภาพ</b-button
            >
          </div>

          <b-row class="flex-grow-1">
            <template v-for="(item, index) in idCardInfo">
              <b-col
                :cols="item.key === 'address' ? 12 : 4"
                :key="index"
                :class="{ 'mt-3': index > 2 }"
              >
                <div class="font-weight-bold text-gray">{{ item.label }}</div>
                <div
                  class="font-weight-bold"
                  v-if="
                    item.key == 'birthday' ||
                    item.key == 'issue_date_id_card' ||
                    item.key == 'expire_date_id_card'
                  "
                >
                  {{ item.val | moment($formatDateNew) }}
                </div>
                <div class="font-weight-bold" v-else>{{ item.val }}</div>
              </b-col>
            </template>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  props: {
    img: {
      required: true,
    },
    type: {
      required: false,
      default: "img",
    },
    form: {
      required: false,
    },
  },
  data() {
    return {
      isTransfersModal: true,
      isshowIdCardImg: false,
      idCardInfo: [
        {
          key: "id_card",
          label: "Identity Number",
          val: "",
        },
        {
          key: "prefix",
          label: "Title",
          val: "",
        },
        {
          key: "gender",
          label: "Gender",
          val: "",
        },
        {
          key: "first_name_th",
          label: "ชื่อ - นามสกุล (TH)",
          val: "",
        },

        {
          label: "Name - Surname (EN)",
          key: "first_name_en",
          val: "",
        },
        {
          key: "birthday",
          label: "Birthday",
          val: "",
        },
        {
          key: "address",
          label: "ทีอยู่ / Address",
          val: "",
        },
        {
          key: "issue_date_id_card",
          label: "วันออกบัตรประชาชน / Issue Date ID Card",
          val: "",
        },
        {
          key: "expire_date_id_card",
          label: "วันหมดอายุบัตรประชาชน / Expire Date ID Card",
          val: "",
        },
        {
          key: "issue_place_id_card",
          label: "สถานที่ออกบัตรประชาชน / Issue Place ID Card",
          val: "",
        },
      ],
      showIdCard: false,
    };
  },
  created() {
    this.idCardInfo.forEach((item) => {
      if (item.key === "address") {
        const isBangkok = this.form.province.includes("กรุงเทพ");
        const addressParts = [
          this.form.home_address,
          this.form.alley ? `ซอย${this.form.alley}` : null,
          this.form.road ? `ถนน${this.form.road}` : null,
          this.form.subdistrict
            ? isBangkok
              ? `แขวง${this.form.subdistrict}`
              : `ตำบล${this.form.subdistrict}`
            : null,
          this.form.district
            ? isBangkok
              ? `เขต${this.form.district}`
              : `อำเภอ${this.form.district}`
            : null,
          this.form.province
            ? isBangkok
              ? this.form.province
              : `จังหวัด${this.form.province}`
            : null,
          this.form.zip_code,
          "ประเทศไทย",
        ].filter(Boolean);
        item.val = addressParts.join(" ");
      } else if (item.key === "first_name_th") {
        item.val = `${this.form.first_name_th || ""} ${
          this.form.last_name_th || ""
        }`.trim();
      } else if (item.key === "first_name_en") {
        item.val = `${this.form.first_name_en || ""} ${
          this.form.last_name_en || ""
        }`.trim();
      } else {
        item.val = this.form[item.key] || "";
      }
    });
  },
  methods: {
    showIdCardImg() {
      this.isshowIdCardImg = !this.isshowIdCardImg;
    },
  },
};
</script>

<style lang="scss">
.card-image-overlay {
  // position: fixed;
  // top: 0;
  // width: 100%;
  // height: 100vh;
  // left: 0;
  // z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: rgba(0, 0, 0, 0.39);
  .card-image-panel {
    // max-width: 60vw;
    width: fit-content;
    text-align: right;
    img {
      height: auto;
      width: 100%;
      // aspect-ratio: 16/9;
      //   object-fit: contain;
    }
  }
}
.close-icon {
  font-size: 16px;
  cursor: pointer;
  color: white;
}
.hide-line {
  border: unset !important;
  background: transparent;
}
.bg-transparent {
  background-color: transparent;
}
</style>
